/** Auto-advance delay after picking a Likert/context value (ms). */
export const ADVANCE_DELAY_MS = 220;

/** Antwortwert für „Keine Angabe". Wird aus allen Score-Mittelwerten
 * herausgefiltert und in der Auswertung explizit als „keine Angabe"
 * dargestellt – nie als Skalenwert 0. */
export const SKIP_VALUE = 0;

/** ScoreDial count-up animation duration (ms). */
export const DIAL_DURATION_MS = 800;

/** Scroll-reveal entrance duration for sections (ms). */
export const SECTION_REVEAL_MS = 500;

/** External zeb legal pages (opened in a new tab). */
export const ZEB_PRIVACY_URL = 'https://zeb-consulting.com/de-DE/datenschutz-umfragen';
export const ZEB_IMPRINT_URL = 'https://zeb-consulting.com/de-DE/impressum';
